import { render } from "./StringField.vue?vue&type=template&id=bb6022b0"
import script from "./StringField.vue?vue&type=script&lang=js"
export * from "./StringField.vue?vue&type=script&lang=js"
script.render = render

export default script